export interface AppConfig {
  apiBase: string;
  nonce: string;
  complaintUrl: string;
  showDisclaimer: boolean;
  defaultRadiusMiles: number;
}

export function readConfig(mount: HTMLElement): AppConfig {
  return {
    apiBase: mount.dataset.apiBase ?? '/wp-json/snhd-eh-restaurants/v1',
    nonce: mount.dataset.nonce ?? '',
    complaintUrl:
      mount.dataset.complaintUrl ?? 'https://aca-prod.accela.com/snhd/Default.aspx',
    showDisclaimer: (mount.dataset.showDisclaimer ?? 'true') !== 'false',
    defaultRadiusMiles: (() => {
      const raw = mount.dataset.defaultRadiusMiles ?? '1';
      const parsed = parseFloat(raw);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
    })(),
  };
}
